import React from "react";

// Shared "how to get your iCal link" instructions for connecting TrainingPeaks.
export default function TrainingPeaksHelp() {
  return (
    <div data-testid="tp-help" className="text-[11px] text-zinc-400 leading-relaxed mb-2">
      <p className="text-zinc-300 mb-1">Pull in your real sessions. To get your link (use a desktop browser):</p>
      <ol className="list-decimal pl-4 space-y-0.5">
        <li>Sign in at <span className="text-zinc-300">trainingpeaks.com</span> on a desktop browser.</li>
        <li>Click <span className="text-zinc-300">your name</span> in the top-right corner and choose <span className="text-zinc-300">Settings</span>.</li>
        <li>Scroll down to the <span className="text-zinc-300">Calendar Export</span> section.</li>
        <li>Copy your unique workout calendar <span className="text-zinc-300">(iCal / webcal) URL</span>.</li>
        <li>Paste it below and hit Connect.</li>
      </ol>
      <p className="mt-1.5 text-[#FFB454]">Note: TrainingPeaks only offers Calendar Sync (the iCal feed) to <span className="font-semibold">Premium</span> athletes.</p>
    </div>
  );
}
